/* eslint-disable */
import React, { Component } from 'react'
import compose from 'recompose/compose'
import { connect } from 'react-redux'

import classNames from '@/helpers/classNames'
import translate from '@/i18n/translate'
import Link from 'redux-first-router-link'
import { ROUTE_NEWSLETTERS_EDIT } from '@/state/types/routes'
import { showModal, hideModal } from '@/state/actions/modal'

import {
  crudUpdate as crudUpdateAction,
  crudCreate as crudCreateAction,
} from '@/state/actions/data'
import { goToPage as goToPageAction } from '@/state/actions/routes'
import { showNotification } from '@/state/actions/notification'

import { Container, Row, Column } from '@/ui/Element'

import SetupNewsletter from './setupNewsletter'
import BuildLayout from './buildLayout'
import AddContent from './addContent'

import generateUUID from '@/helpers/generateUUID'

import EditBlock from '@/ui/Blocks/Edit'
import AddCircle from '@/icons/AddCircle'

import Button from '@/ui/Button/Button'

import {
  RTE as RteText,
  HEADER as HeaderText,
  BUTTON as ButtonText,
} from '@/state/types/defaultLabel'

import TriangleIcon from '@/icons/TriangleRight'
import MailSetupIcon from '@/media/svg/mail-setup.svg'
import MailLayoutIcon from '@/media/svg/mail-layout.svg'
import Close from '@/media/svg/close.svg'

import deepEqual from '@/helpers/fastDeepEqual'
// import clearRender from 'clear-render'

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

class EditNewsletter extends Component {
  state = {
    items: this.props.data,
    editedItem: 0,
    images: {},
    selected: null,
  }
  dragging = false
  formRef = null
  emptyListState = false

  componentWillReceiveProps(nextProps) {
    // Initialize the state only once, when the state has items just ignore props until component
    // gets saved or re-set to the vanilla state
    if (
      nextProps.data !== this.props.data &&
      !this.state.items.length &&
      nextProps.data.length &&
      !this.emptyListState
    ) {
      this.setState({ items: nextProps.data })
      // Uncomment to debug
      // this.setState({ items: nextProps.data }, () => console.log(this.state))
      // console.log('change', nextProps.data)
    }
  }

/*   shouldComponentUpdate(nextProps, nextState) {
    const d = deepEqual
    const ret = !(d(nextProps, this.props) && d(nextState, this.state))
    return ret
    // return !(
    //   JSON.stringify(nextProps) === JSON.stringify(this.props) &&
    //   JSON.stringify(nextState) === JSON.stringify(this.state)
    // )
  } */

  componentDidUpdate() {
    if (this.state.selected) {
      const active = document.querySelector(`.block-active[data-id="${this.state.selected.id}"]`)
      if (active !== this.active) {
        this.active = active
        if (active) {
          this.active.scrollIntoView({
            block: 'start',
            behavior: 'smooth',
          })
        }
      }
    }
  }

  onEditBlock = (item, type, value) => {
    const additionalStates = {}
    if (type === 'current') {
      // Just switching currently edited item
      this.setState({ editedItem: value })
      return
    } else if (type === 'numItems' && this.state.editedItem >= value) {
      additionalStates.editedItem = value - 1
    }

    const images = Object.assign({}, this.state.images)
    const items = this.state.items.reduce((acc, val) => {
      // Special case for akademie - when numItems is passed we change number of links
      if (
        ['Card / Akademie', 'Card / Akademie custom', 'Card / Akademie + header'].includes(
          item.type,
        )
      ) {
        let data = []
        if (type === 'numItems') {
          // Check if data exists and it's an array
          if (item.data && Array.isArray(item.data)) {
            // Reduce array elements to max limit
            if (item.data.length > value) {
              data = item.data.slice(0, value)
            } else {
              data = item.data.slice(0)
              // Add new elements to fill the gap
              for (let i = item.data.length; i < value; i++) {
                data.push({
                  header: '',
                  text: '',
                  buttontext: '',
                  buttonurl: '',
                })
              }
            }
          } else {
            for (let i = 0; i < value; i++) {
              data.push({
                header: '',
                text: '',
                buttontext: '',
                buttonurl: '',
              })
            }
          }
          return [...acc, { ...val, ...(item.id === val.id && { data }) }]
        } else {
          // Handling single link editing (passing an array argument with index and value)
          // Make sure array is passed
          if (Array.isArray(type)) {
            const [index, field] = type
            data = item.data.slice(0)
            data[index][field] = value
            return [...acc, { ...val, ...(item.id === val.id && { data }) }]
          }
        }
        return [...acc, { ...val, ...(item.id === val.id && { [type]: value }) }]
      } else if (item.type === 'Card / Infothek' || item.type === 'Card / Infothek + Icons') {
        let data = []
        if (type === 'numItems') {
          // Check if data exists and it's an array
          if (item.data && Array.isArray(item.data)) {
            // Reduce array elements to max limit
            if (item.data.length > value) {
              data = item.data.slice(0, value)
            } else {
              data = item.data.slice(0)
              // Add new elements to fill the gap
              for (let i = item.data.length; i < value; i++) {
                const dummyObj = { linkurl: '', linktext: '' }
                if (item.type === 'Card / Infothek + Icons') {
                  dummyObj.linktext = ''
                  dummyObj.linktype = 'play'
                  dummyObj.linkurl = ''
                }
                data.push(dummyObj)
              }
            }
          } else {
            for (let i = 0; i < value; i++) {
              const dummyObj = { linkurl: '', linktext: '' }
              if (item.type === 'Card / Infothek + Icons') {
                dummyObj.linktext = ''
                dummyObj.linktype = 'play'
                dummyObj.linkurl = ''
              }
              data.push(dummyObj)
            }
          }
          return [...acc, { ...val, ...(item.id === val.id && { data }) }]
        } else if (Array.isArray(type)) {
          const [index, field] = type
          data = item.data.slice(0)
          data[index][field] = value
          return [...acc, { ...val, ...(item.id === val.id && { data }) }]
        }
      }
      return [...acc, { ...val, ...(item.id === val.id && { [type]: value }) }]
    }, [])
    // We are asuming that currently edited item is the selected one
    // and since editing an item creates a new object, make sure selection
    // points to this newly created obj
    this.setState({
      items,
      selected: items.find(i => i.id === item.id),
      images,
      ...additionalStates,
    })
  }

  onSelectBlock = (item, e) => {
    if (this.dragging) {
      return false
    }
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }

    this.setState({
      selected: item,
      editedItem: 0,
    })
  }

  removeBlock = (e, id) => {
    // Prevent propagation and default when clicking on remove icon - we don't
    // want click event being propagated on widget as that would cause widget selection
    e.preventDefault()
    e.stopPropagation()

    const items = Array.from(this.state.items).filter(item => item.id !== id)
    const additionalState = {}
    if (this.state.selected && this.state.selected.id === id) {
      additionalState.selected = null
    }
    if (!items.length) {
      this.emptyListState = true
    }
    this.setState({ items, ...additionalState })
  }

  addNew = () => {
    this.props.dispatch(
      this.props.goToPage(this.props.pageType, null, { id: this.props.id, step: 'add' }),
    )
  }

  newBlock = types => {
    const items = Array.from(this.state.items)
    types.forEach(type => {
      // const maxId = Math.max(...items.map(o => o.id))
      const item = { id: generateUUID(), type }
      if (item.type === 'Card / Text only') {
        item.header = HeaderText
        item.text = RteText
      } else if (item.type === 'Card / Image') {
        item.buttonlink = ''
        item.buttontext = ButtonText
      } else if (item.type === 'Card / Image + Text (no CTA)') {
        item.header = HeaderText
        item.text = RteText
      } else if (item.type === 'Card / Image + Text') {
        item.header = HeaderText
        item.text = RteText
        item.buttonlink = ''
        item.buttontext = ButtonText
      } else if (item.type === 'Card / Infothek') {
        item.header = HeaderText
      }
      items.push(item)
    })
    this.emptyListState = false
    // If multiple items are selected don't push selection, otherwise select added element
    this.setState({ items, ...(types.length === 1 && { selected: [...items].pop() }) })
    this.goBuild()
  }

  duplicateBlock = id => {
    const items = Array.from(this.state.items)
    const item = items.find(item => item.id === id)
    items.splice(items.indexOf(item) + 1, 0, { ...item, id: generateUUID() })
    this.emptyListState = false
    this.setState({ items })
  }

  onDragStart = result => {
    // Using the flag to prevent click from firing after releasing the dragged element
    this.dragging = true
  }

  onDragEnd = result => {
    this.dragging = false
    // dropped outside the list
    if (!result.destination) {
      return
    }

    this.setState({
      items: reorder(this.state.items, result.source.index, result.destination.index),
    })
  }

  closeModal = () => {
    this.props.dispatch(hideModal())
    this.goBack(true)
  }

  goBack = force => {
    if (
      force ||
      ((!Object.keys(this.props.currentValues).length ||
        JSON.stringify(this.props.currentValues) === JSON.stringify(this.props.initialValues)) &&
        JSON.stringify(this.props.data) === JSON.stringify(this.state.items))
    ) {
      this.props.dispatch(this.props.goToPage(this.props.currentRouteData.parent))
    } else {
      this.props.dispatch(
        showModal({
          title: 'Save before closing?',
          record: this.props.currentValues,
          content:
            'You can choose to save or cancel all the changes made on the $title newsletter.',
          buttons: [
            <Button
              theme={this.props.theme}
              classes="inverted"
              key="cancel"
              onClick={this.closeModal}
            >
              Cancel changes & close
            </Button>,
            <Button
              theme={this.props.theme}
              classes="success"
              key="save"
              onClick={() => {
                this.saveNewsletter(false)
                this.closeModal(true)
              }}
            >
              Save and close
            </Button>,
          ],
        }),
      )
    }
  }

  goBuild = save => {
    this.props.dispatch(
      this.props.goToPage(this.props.pageType, null, { id: this.props.id, step: 'build' }),
    )
  }

  getMenu = () => {
    const view = this.props.step
    const pageType = this.props.pageType
    const goToPage = this.props.goToPage
    const dispatch = this.props.dispatch
    const id = this.props.id

    return (
      <Column classes="newsletter-edit-sidebar">
        <Choose>
          <When condition={view === 'build'}>
            <div>
              <div
                className={this.props.theme['sidebar-inactive']}
                onClick={() => dispatch(goToPage(pageType, null, { id }))}
              >
                <span>
                  <MailSetupIcon fill="currentColor" width="40" height="40" />Setup newsletter
                </span>
              </div>
              <div className={this.props.theme['sidebar-active']}>
                <span>
                  <MailLayoutIcon fill="currentColor" width="40" height="40" />Build layout
                </span>
              </div>
            </div>
          </When>
          <Otherwise>
            <div>
              <div
                className={this.props.theme['sidebar-active']}
                onClick={() => dispatch(goToPage(pageType, null, { id }))}
              >
                <span>
                  <MailSetupIcon fill="currentColor" width="40" height="40" />Setup newsletter
                </span>
              </div>
              <div
                className={this.props.theme['sidebar-inactive']}
                onClick={() =>
                  this.saveNewsletter(false, {
                    redirectTo: { type: ROUTE_NEWSLETTERS_EDIT, step: 'build' },
                    buildLayout: true,
                  })}
              >
                <span>
                  <MailLayoutIcon fill="currentColor" width="40" height="40" />Build layout
                </span>
              </div>
            </div>
          </Otherwise>
        </Choose>
      </Column>
    )
  }

  saveNewsletter = (preview, meta) => {
    if (this.props.id) {
      // Check if something is changed
      if (
        JSON.stringify(this.props.currentValues) === JSON.stringify(this.props.initialValues) &&
        JSON.stringify(this.props.data) === JSON.stringify(this.state.items)
      ) {
        // Nothing has changed, just redirect to build page (not for preview and save)
        if (!preview) {
          // Skip jumping to build screen when user is saving (meta isn't set in this case)
          if (meta) {
            this.goBuild()
          }
          // Show notification when saving (Skip for preview action and on Build layout click)
          if (!meta.buildLayout) {
            this.props.dispatch(
              showNotification(this.props.id, `Nothing to save, there were no changes`),
            )
          }
        }
      } else {
        // buildLayout is just a flag that notifies us user has clicked build layout button
        if (meta && meta.buildLayout) {
          delete meta.buildLayout
        }
        // Submit changes•
        this.props.crudUpdate(
          'newsletters',
          this.props.id,
          { data: this.state.items, ...this.props.currentValues },
          { data: this.props.data, ...this.props.initialValues },
          null,
          {
            ...meta,
            message: `${this.props.currentValues.title || this.props.initialValues.title} saved.`,
            ...(preview && { message: false }), // Don't show any message when preview is hit!
          },
        )
      }
    } else {
      this.props.crudCreate(
        'newsletters',
        { data: this.state.items, ...this.props.currentValues },
        null,
        {
          ...meta,
          message: `${this.props.currentValues.title || this.props.initialValues.title} created.`,
        },
        ...(preview && { message: false }),
      )
    }
    if (preview) {
      setTimeout(() => {
        fetch(`${process.env.API_URL}/api/build/check/${this.props.id}`)
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              return response.text()
            }
            return Promise.reject()
          })
          .then(data => {
            window.open(
              `${process.env.URL}/newsletters/${String(this.props.id).padStart(4, '0')}/${data}`,
              'preview',
            )
          })
      }, 500)
    }
  }
  runSubmit = values => {
    this.saveNewsletter(false, { redirectTo: { type: ROUTE_NEWSLETTERS_EDIT, step: 'build' } })
  }
  render() {
    const { theme, title, step, saving, initialValues, currentValues, ...props } = this.props // eslint-disable-line
    const values = {
      ...initialValues,
      ...currentValues,
    }
    const saveDisabled = !(
      values.contact_id &&
      values.title &&
      values.product_id &&
      values.scheduled_at
    )
    if (step === 'add') {
      return <AddContent {...this.props} goBuild={this.goBuild} addNew={this.newBlock} />
    }
    return (
      <div className={theme['newsletter-edit']}>
        <div className={classNames(theme, 'app-bar-inverse')}>
          <Row>
            <div className={classNames(theme, 'app-bar-inverse-item', 'app-bar-inverse-active')}>
              <Link to="/">Newsletters</Link>
            </div>
            <div className={classNames(theme, 'app-bar-inverse-item')}>
              <TriangleIcon size=".6em" />
              {title || 'New'}
            </div>
            <div className={classNames(theme, 'app-bar-inverse-item', 'left-margin-auto')}>
              <Button
                theme={theme}
                classes="primary"
                styles={['va-middle', 'right-margin-8']}
                disabled={saveDisabled || !(this.state.items && this.state.items.length)}
                onClick={e => this.saveNewsletter(true)}
              >
                Preview
              </Button>
              <Button
                theme={theme}
                classes="success"
                styles={['va-middle', 'right-margin-24']}
                disabled={saveDisabled}
                onClick={e => this.saveNewsletter(false)}
              >
                Save
              </Button>
              <Button
                theme={theme}
                classes="clean"
                styles="va-middle"
                style={{ width: 'auto' }}
                onClick={e => this.goBack()}
              >
                <Close fill="currentColor" width="40" height="40" />
              </Button>
            </div>
          </Row>
        </div>
        <Container>
          <Row>
            {this.getMenu()}
            <Column
              classes={[
                'newsletter-edit-content',
                {
                  [theme['with-aside']]: step === 'build',
                  [theme['newsletter-selected']]: !!this.state.selected,
                },
              ]}
            >
              <Choose>
                <When condition={step === 'build'}>
                  <BuildLayout
                    theme={theme}
                    newsletterId={this.props.id}
                    items={this.state.items}
                    images={this.state.images}
                    addNew={this.addNew}
                    selected={this.state.selected}
                    onDragStart={this.onDragStart}
                    onDragEnd={this.onDragEnd}
                    onSelect={this.onSelectBlock}
                    duplicateBlock={this.duplicateBlock}
                    removeBlock={this.removeBlock}
                    onChange={this.onEditBlock}
                    {...props}
                  />
                </When>
                <Otherwise>
                  <SetupNewsletter
                    formRef={ref => {
                      this.formRef = ref
                    }}
                    initialValues={this.props.initialValues}
                    theme={theme}
                    runSubmit={this.runSubmit}
                    goBack={e => this.goBack()}
                    {...props}
                  />
                </Otherwise>
              </Choose>
            </Column>
            <If condition={step}>
              <Column classes={['newsletter-edit-sidebar', 'newsletter-edit-aside']}>
                <div>
                  <Choose>
                    <When condition={this.state.items && this.state.items.length}>
                      <Button
                        theme={theme}
                        classes="secondary"
                        styles="va-middle"
                        onClick={this.addNew}
                      >
                        <AddCircle />&nbsp; New content block
                      </Button>
                      <If condition={this.state.selected}>
                        <EditBlock
                          newsletterId={this.props.id}
                          item={this.state.selected}
                          images={this.state.images}
                          theme={theme}
                          current={this.state.editedItem}
                          onChange={this.onEditBlock}
                        />
                      </If>
                    </When>
                    <Otherwise>
                      <div />
                    </Otherwise>
                  </Choose>
                </div>
              </Column>
            </If>
          </Row>
        </Container>
      </div>
    )
  }
}

function mapStateToProps(state, props) {
  const id = state.location.payload.id
  const newsletter = state.rest.newsletters.data[id]
  const initialValues = {}

  if (newsletter) {
    initialValues.id = newsletter.id
    initialValues.title = newsletter.title
    initialValues.location = newsletter.location
    initialValues.product_id = newsletter.product_id
    initialValues.contact_id = newsletter.contact_id
    initialValues.scheduled_at = newsletter.scheduled_at
    initialValues.status = newsletter.status === 'processed'
  }

  return {
    id,
    initialValues,
    currentValues: (state.form.setupNewsletter && state.form.setupNewsletter.values) || {},
    step: state.location.payload.step,
    saving: state.rest.saving,
    pageType: state.location.type,
    title: (newsletter && newsletter.title) || '',
    data: (newsletter && newsletter.data) || [],
    // isLoading: state.rest.loading > 0, // Not used, its causing unnecessary re-render
  }
}

// const NewsletterEdit = clearRender(EditNewsletter)

const enhance = compose(
  connect(mapStateToProps, {
    goToPage: goToPageAction,
    crudUpdate: crudUpdateAction,
    crudCreate: crudCreateAction,
  }),
  translate,
)

export default enhance(EditNewsletter)
// export default enhance(NewsletterEdit)



// WEBPACK FOOTER //
// ./view/Dashboard/editNewsletter.js